import React, { createContext, useMemo, useState } from 'react';

import { Route, useLocation } from 'react-router-dom';

import CodifyDBView from 'components/codify_db/CodifyDBView';
import UserPermission from 'lib/enums/UserPermission';
import useUserPermissions from 'lib/hooks/useUserPermissions';
import UPBViewer from 'components/upb_viewer/UPBViewer';
import useViewGMV from 'lib/hooks/useViewGMV';

const UPBViewContext = createContext({});

function UPBViewContainer() {
  const location = useLocation();
  const hasUserPermissions = useUserPermissions();
  const viewGMV = useViewGMV();
  const salesView = location.pathname.includes('sales-viewer');
  const mfrView = location.pathname.includes('mfr-viewer');
  const [InvoiceAndOrderingGMV, setInvoiceAndOrderingGMV] = useState(null);

  const viewScorePermissions = useMemo(
    () => hasUserPermissions([UserPermission.UPB_SCORE_VIEW]),
    [hasUserPermissions],
  );

  // poop icon and the L5 GMV percentage badge
  const viewIconPermissions = useMemo(
    () => hasUserPermissions([UserPermission.UPB_VIEW_ADMIN]),
    [hasUserPermissions],
  );

  const viewScore = viewScorePermissions && !salesView;
  const viewIcon = viewIconPermissions && !salesView;
  const baseURL = salesView ? 'upb-sales-viewer' : 'upb-viewer';

  return (
    <UPBViewContext.Provider
      value={{
        mfrView,
        viewGMV,
        viewScore,
        viewIcon,
        baseURL,
        InvoiceAndOrderingGMV,
        setInvoiceAndOrderingGMV,
      }}
    >
      <Route path="/upb-viewer/:l1_category?/:l2_category?/:l3_category?/:l4_category?">
        <UPBViewer />
      </Route>
      <Route path="/upb-sales-viewer/:l1_category?/:l2_category?/:l3_category?/:l4_category?">
        <UPBViewer />
      </Route>
      <Route path="/upb-mfr-viewer">
        <CodifyDBView />
      </Route>
    </UPBViewContext.Provider>
  );
}

export default UPBViewContainer;
export { UPBViewContext };
